import czflag from '../assets/img/flag-cz.png';
import enflag from '../assets/img/flag-en.png';

const supportedLangs = {
    en: { img: enflag, alt: 'GB', switchTo: 'cz', nextImg: czflag },
    cz: { img: czflag, alt: 'CZ', switchTo: 'en', nextImg: enflag }
};

const LanguageSwitch = ({ lang, changeLanguage }) => {
    const current = supportedLangs[lang] ?? supportedLangs.cz;

    const handleChange = () => {
        if (supportedLangs[current.switchTo]) {
            changeLanguage(current.switchTo);
        } else {
            changeLanguage('cz');
        }
    };

    return (
        <div className='language-selector' onClick={handleChange}>
            <img src={current.nextImg} alt={supportedLangs[current.switchTo]?.alt} />
        </div>
    );
}

export default LanguageSwitch;